import Rollbar, { type Configuration } from 'rollbar'

import PackageJson from '../../../../package.json'
import { env } from './env'

export const rollbarConfig: Configuration = {
  accessToken: 'af531edbd15740c09dcd5a201c679850',
  captureDeviceInfo: true,
  environment: env.MODE,
  captureUncaught: true,
  enabled: env.VITE_ROLLBAR_ENABLED,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: PackageJson.version,
        source_map_enabled: true,
      },
    },
  },
}

export const rollbar = new Rollbar(rollbarConfig)
